import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// Pages
import Home from './Pages/Home';
import Acceptdomesticpayment from './Pages/Acceptdomesticpayments';
import Paymentplatform from './Pages/Paymentplatform';
import Payouts from './Pages/Payouts';
import About from './Pages/About';
import Privacy from './Pages/Privacy';
import Pricing from './Pages/Pricing';
import TermCondition from './Pages/TermCondition';
import CancellationRefund from './Pages/CancellationRefund';
import Shipping from './Pages/Shipping';
import Contact from './Pages/Contact';
import Onboardingplatform from './Pages/Onboardingplatform';
import Signin from './Pages/Signin';
import Partnerwithus from './Pages/Partnerwithus';

import ProfessionCheck from './Pages/Solution/ProfessionCheck'
import VehicleVerigication from './Pages/Solution/ProfessionCheck'
import KycVerigicationApi from './Pages/Solution/ProfessionCheck'
import BusinessApi from './Pages/Solution/ProfessionCheck'
import FinancicalCheckApi from './Pages/Solution/ProfessionCheck'

import ApiPlatform from './Pages/Solution/ApiPlatform'

import SubscribeForm from './Pages/Solution/SubscribeForm'

// Components
import Header from './Include/Header';
import Footer from './Include/Footer';

// Layout defined inline
const Layout = ({ children }) => {
  const location = useLocation();
  const hideLayoutRoutes = ['/Signin'];
  const shouldHideLayout = hideLayoutRoutes.includes(location.pathname);

  return (
    <>
      {!shouldHideLayout && <Header />}
      <main>{children}</main>
      {!shouldHideLayout && <Footer />}
    </>
  );
};

// App Component
function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Server-Infrastructure-Support" element={<Acceptdomesticpayment />} />
          <Route path="/Server-Infrastructure-Platform" element={<Paymentplatform />} />
          <Route path="/onboarding-platform" element={<Onboardingplatform />} />
          <Route path="/Cloud-Infrastructure-Solutions" element={<Payouts />} />
          <Route path="/About" element={<About />} />

          <Route path="/Pricing" element={<Pricing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/termCondition" element={<TermCondition />} />
          <Route path="/cancellationRefund" element={<CancellationRefund />} />
          <Route path="/shipping" element={<Shipping />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Signin" element={<Signin />} />
          <Route path="/Partnerwithus" element={<Partnerwithus />} />

          <Route path="/profession-check" element={<ProfessionCheck />} />
          <Route path="/vehicle-verigication" element={<VehicleVerigication />} />
          <Route path="/kyc-verigication-api" element={<KycVerigicationApi />} />
          <Route path="/business-api" element={<BusinessApi />} />
          <Route path="/financical-check-api" element={<FinancicalCheckApi />} />

          <Route path="/ApiPlatform" element={<ApiPlatform />} />

          <Route path="/subscribe" element={<SubscribeForm />} />

        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
